var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMarkUpright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.402,
    height: 116.547,
    viewBox: "0 0 75.402 116.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Unsaved_changes",
    x: 0,
    y: 0,
    width: 75.402,
    height: 116.547,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Unsaved_changes)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Unsaved_changes-2",
    "data-name": "Unsaved  changes",
    d: "M7322.085,5910.407a11.688,11.688,0,1,1,16.526.022,11.662,11.662,0,0,1-16.526-.022Zm14.871-29.1-13.259-.019a2.754,2.754,0,0,1-2.745-2.754l-.017-11.331c-.011-7.427,6.284-10.828,10.881-13.312,6.811-3.679,9.655-5.927,9.649-10.327a11.4,11.4,0,0,0-11.232-11.5c-5.141-.007-9.529,2.837-13.061,8.462a1.391,1.391,0,0,1-1.87.491l-13.828-7.958a1.414,1.414,0,0,1-.51-1.945c7-11.513,17.343-17.823,29.242-17.807a30.215,30.215,0,0,1,29.956,30.283c.022,16.3-15.284,20.956-19.445,26.821-.7.994-.944,5.331-1.025,8.225a2.738,2.738,0,0,1-2.734,2.671Z",
    transform: "translate(-7292.76 -5807.3)",
    fill: "#56aa1c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkUpright);
export default __webpack_public_path__ + "static/media/QuestionMarkUpright.cf1f64bbc9d15302834779f5c8df68ff.svg";
export { ForwardRef as ReactComponent };